import { h } from '../pragma.mjs';

export default (isPublic) => {

    return (
        <div>

            <gov-breadcrumbs wcag-label="Úroveň zanoření v rozcestníku">
                <ul class="breadcrumbs">
                    <li><gov-icon type="basic" name="chevron-right"></gov-icon><a id="rozcestnikRoot" href="#">Domů</a></li>
                    <li><gov-icon type="basic" name="chevron-right"></gov-icon><a id="rozcestnikZapisy" href="#">Zápisy</a></li>
                    <li><gov-icon type="basic" name="chevron-right"></gov-icon><a id="postavilJsemStavbu" href="">Změna údajů o stavbách</a></li>
                    <li><gov-icon type="basic" name="chevron-right"></gov-icon><strong>Stavba na vlastním pozemku</strong></li>
                </ul>
            </gov-breadcrumbs>
            
            <gov-tiles role="list">
                <gov-tile role="listitem" id="rozcestnikPostavil2S8414" href="#">
                    <p>Nejedná se o dočasnou stavbu ani stavbu, která je součástí liniové stavby</p>
                    <h3 slot="title">Stavba je součástí pozemku</h3>
                    <gov-icon type="complex" name="house" slot="icon"></gov-icon>
                </gov-tile>
                <gov-tile role="listitem" href={(isPublic) ? "https://nv.cuzk.gov.cz/" : "/nv?akce=VytvorNavrh"} target="_blank">
                    <p>Jedná se o dočasnou stavbu nebo stavbu, která je součástí liniové stavby</p>
                    <h3 slot="title">Stavba není součástí pozemku&nbsp;<gov-icon class="h3icon" type="basic" name="box-arrow-up-right"></gov-icon></h3>
                    <gov-icon type="complex" name="property" slot="icon"></gov-icon>
                </gov-tile>             
            </gov-tiles>
        </div>
    )

}